import React from "react";
import {Price} from "./Price";
import styled from "styled-components";
import {months} from "../../../util/timeDescription";
import {DateTimeFormatter, LocalDate} from "js-joda";

const MissingPriceText = styled.div`
    font-size: 10px;
    text-align: right;
    margin-right: 8px;
`;

const MissingEntryPrice = ({idea}) => {
    if (idea.stockPriceExpectation) {
        if (idea.stockPriceExpectation.currentlyInHours) {
            if (idea.stockEntryPrice === null) {
                return <MissingPriceText className="t-stock-entry-price">Illiquid</MissingPriceText>;
            }
            if (idea.stockPriceExpectation.availability === "Intraday") {
                return <MissingPriceText className="t-stock-entry-price">
                    <div>Delayed</div>
                    <div>{"(" + idea.stockPriceExpectation.delayMins + " mins)"}</div>
                </MissingPriceText>;
            }
        }
        const event = idea.stockPriceExpectation.availability === "Intraday" ? "Open" : "EOD";
        const authorLocalDate = LocalDate.parse(idea.stockPriceExpectation.tradingOn);
        const dateString = months[authorLocalDate.monthValue() - 1] + authorLocalDate.format(DateTimeFormatter.ofPattern(" dd"));
        return <MissingPriceText className="t-stock-entry-price">
            <div>{"Awaiting " + event}</div>
            <div>{"(" + dateString + ")"}</div>
        </MissingPriceText>;
    }

    return <MissingPriceText className="t-stock-entry-price">Awaiting Price</MissingPriceText>;
};

export function hidePrice(idea) {
    return idea.pricingProgress === 0.0;
}

export const EntryPrice = ({idea}) => {
    if (hidePrice(idea)) {
        return <MissingEntryPrice idea={idea}/>;
    }
    return <>
        <Price key="stock" price={idea.stockEntryPrice} currency={idea.stockCurrency} className="t-stock-entry-price"/>
        { idea.pricingProgress <= 0.0 || idea.hasBenchmarkEntryPrice
          ? null
          : <MissingPriceText key="benchmark">Awaiting Benchmark</MissingPriceText>
        }
    </>;
};